var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m820.8 714c-97.199 20.398-164.4 96-148.8 166.8 15.602 72 108 112.8 205.2 92.398 82.801-18 144-74.398 150-135.6v-13.199-472.8-229.2c0-25.199-20.398-44.398-45.602-44.398-7.1992 0-14.398 2.3984-21.602 6l-516 138c-25.199 0-45.602 20.398-45.602 44.398v596.4c-33.602-10.801-74.398-13.199-116.4-4.8008-97.199 20.398-164.4 96-148.8 166.8 15.602 72 108 112.8 205.2 92.398 82.801-18 144-74.398 150-135.6v-13.199-468l445.2-120v337.2c-31.195-10.793-71.992-13.195-112.79-3.5938z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNotes);
export default __webpack_public_path__ + "static/media/music-notes.9dfd2526182da770b2ed0c3ad1b58ca8.svg";
export { ForwardRef as ReactComponent };